import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { listcategory } from '../services/homeser';

export const Header = () => {
    const navigate = useNavigate();
    const [clist, setCList] = useState([]);
    // Build a route slug from a category name (e.g. "Save the date" -> "/savethedate")
    const slugify = (name) => '/' + String(name || '').toLowerCase().replace(/\s+/g, '');

    function handleshow() {
        const categorySidebar = document.querySelector('.category-sidebar');
        categorySidebar.classList.add('active');
    }

    function handlehide() {
        const categorySidebar = document.querySelector('.category-sidebar');
        categorySidebar.classList.remove('active');
    }

    function handleheader() {
        const cartSidebar = document.querySelector('.nav-sidebar');
        cartSidebar.classList.add('active');
    }
    function handleclose() {
        const cartSidebar = document.querySelector('.nav-sidebar');
        cartSidebar.classList.remove('active');
    }

    useEffect(() => {
        listcategory().then((res) => {
            if (res.status) {
                const sdata = res.data.map((x) => { return { ...x, active: x.active == 1 ? "Active" : "Inactive" } });
                setCList(sdata);
            }
        })
    }, [])
    return (

        <>
            <div className="header-top">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-lg-5">
                            <div className="header-top-welcome">
                                <p>Welcome to ASM Wedding cards Store!</p>
                            </div>
                        </div>

                        <div className="col-md-12 col-lg-7">
                            <ul className="header-top-list">
                                <li><a onClick={() => navigate('/contact')} className='text-white'>contact us</a></li>
                                <li><a href='tel:+9865230900'>+91 9865230900</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <header className="header-part">
                <div className="container">
                    <div className="header-content">
                        <div className="header-media-group">
                            <button className="header-user"><i className="fas fa-bars" onClick={handleheader}></i></button>
                            {/* <img src={require("../assets/images/user.png")} alt="user" onClick={handleheader} /> */}
                            <a onClick={() => navigate('/')} ><img src={require("../assets/images/logo.png")} alt="logo" /></a>
                            <button className="header-src"></button>
                            {/* <i className="fas fa-search"></i> */}
                        </div>

                        <a className='header-logo' onClick={() => navigate('/')}>
                            <img src={require("../assets/images/logo.png")} alt="logo" />
                        </a>

                        <form className="header-form">
                            <input type="text" placeholder="Search anything..." />
                            <button><i className="fas fa-search"></i></button>
                        </form>

                        {/* <div className="header-widget-group">

                            <a className='header-widget' onClick={() => navigate('/wishlist')} title='Wishlist'>
                                <i className="fas fa-heart"></i>
                                <sup>0</sup>
                            </a>

                        </div> */}
                    </div>
                </div>
            </header>

            <nav className="navbar-part">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="navbar-content">
                                <ul className="navbar-list">
                                    <li className="navbar-item">
                                        <a className="navbar-link" onClick={() => navigate('/')} >Home</a>
                                    </li>
                                    {clist.map((x) => (
                                        <li className="navbar-item" key={x.id}>
                                            <a className="navbar-link" onClick={() => navigate(slugify(x.category_name))}>{x.category_name}</a>
                                        </li>
                                    ))}
                                    <li className="navbar-item">
                                        <a className="navbar-link" onClick={() => navigate('/weddingwebsite')}>Wedding Website</a>
                                    </li>
                                    <li className="navbar-item dropdown">
                                        <a className="navbar-link dropdown-arrow" >Support</a>
                                        <ul className="dropdown-position-list">

                                            <li><a onClick={() => navigate('/about')}>about us</a></li>
                                            <li><a onClick={() => navigate('/contact')}>contact us</a></li>

                                        </ul>
                                    </li>

                                </ul>

                            </div>
                        </div>
                    </div>
                </div>
            </nav>
            <aside className="category-sidebar">
                <div className="category-header">
                    <h4 className="category-title">
                        <i className="fas fa-align-left"></i>
                        <span>categories</span>
                    </h4>
                    <button className="category-close" onClick={handlehide}><i className="icofont-close"></i></button>
                </div>
                <ul className="category-list">
                    {clist.map((x) => (
                        <li className="category-item" key={x.id}>
                            <a className="category-link dropdown-link" onClick={() => navigate(slugify(x.category_name))}>
                                <span>{x.category_name}</span>
                            </a>
                        </li>
                    ))}
                    <li className="category-item">
                        <a className="category-link dropdown-link" onClick={() => navigate('/weddingwebsite')}>
                            <span>Wedding Website</span>
                        </a>
                    </li>

                </ul>
            </aside>
            <aside className="cart-sidebar">
                <div className="cart-header">
                    <div className="cart-total">
                        <i className="fas fa-shopping-basket"></i>
                        <span>total item (5)</span>
                    </div>
                    <button className="cart-close"><i className="icofont-close"></i></button>
                </div>
                <ul className="cart-list">
                    <li className="cart-item">
                        <div className="cart-media">
                            <a ><img src={require("../assets/images/product/01.jpg")} alt="product" /></a>
                            <button className="cart-delete"><i className="far fa-trash-alt"></i></button>
                        </div>
                        <div className="cart-info-group">
                            <div className="cart-info">
                                <h6><a onClick={() => navigate('/product-single')} >existing product name</a></h6>
                                <p>Unit Price - $8.75</p>
                            </div>
                            <div className="cart-action-group">
                                <div className="product-action">
                                    <button className="action-minus" title="Quantity Minus"><i className="icofont-minus"></i></button>
                                    <input className="action-input" title="Quantity Number" type="text" name="quantity" value="1" />
                                    <button className="action-plus" title="Quantity Plus"><i className="icofont-plus"></i></button>
                                </div>
                                <h6>$56.98</h6>
                            </div>
                        </div>
                    </li>
                    <li className="cart-item">
                        <div className="cart-media">
                            <a ><img src="images/product/02.jpg" alt="product" /></a>
                            <button className="cart-delete"><i className="far fa-trash-alt"></i></button>
                        </div>
                        <div className="cart-info-group">
                            <div className="cart-info">
                                <h6><a onClick={() => navigate('/product-single')} >existing product name</a></h6>
                                <p>Unit Price - $8.75</p>
                            </div>
                            <div className="cart-action-group">
                                <div className="product-action">
                                    <button className="action-minus" title="Quantity Minus"><i className="icofont-minus"></i></button>
                                    <input className="action-input" title="Quantity Number" type="text" name="quantity" value="1" />
                                    <button className="action-plus" title="Quantity Plus"><i className="icofont-plus"></i></button>
                                </div>
                                <h6>$56.98</h6>
                            </div>
                        </div>
                    </li>
                    <li className="cart-item">
                        <div className="cart-media">
                            <a ><img src={require("../assets/images/product/03.jpg")} alt="product" /></a>
                            <button className="cart-delete"><i className="far fa-trash-alt"></i></button>
                        </div>
                        <div className="cart-info-group">
                            <div className="cart-info">
                                <h6><a onClick={() => navigate('/product-single')} >existing product name</a></h6>
                                <p>Unit Price - $8.75</p>
                            </div>
                            <div className="cart-action-group">
                                <div className="product-action">
                                    <button className="action-minus" title="Quantity Minus"><i className="icofont-minus"></i></button>
                                    <input className="action-input" title="Quantity Number" type="text" name="quantity" value="1" />
                                    <button className="action-plus" title="Quantity Plus"><i className="icofont-plus"></i></button>
                                </div>
                                <h6>$56.98</h6>
                            </div>
                        </div>
                    </li>
                    <li className="cart-item">
                        <div className="cart-media">
                            <a ><img src={require("../assets/images/product/04.jpg")} alt="product" /></a>
                            <button className="cart-delete"><i className="far fa-trash-alt"></i></button>
                        </div>
                        <div className="cart-info-group">
                            <div className="cart-info">
                                <h6><a onClick={() => navigate('/product-single')} >existing product name</a></h6>
                                <p>Unit Price - $8.75</p>
                            </div>
                            <div className="cart-action-group">
                                <div className="product-action">
                                    <button className="action-minus" title="Quantity Minus"><i className="icofont-minus"></i></button>
                                    <input className="action-input" title="Quantity Number" type="text" name="quantity" value="1" />
                                    <button className="action-plus" title="Quantity Plus"><i className="icofont-plus"></i></button>
                                </div>
                                <h6>$56.98</h6>
                            </div>
                        </div>
                    </li>
                    <li className="cart-item">
                        <div className="cart-media">
                            <a ><img src={require("../assets/images/product/05.jpg")} alt="product" /></a>
                            <button className="cart-delete"><i className="far fa-trash-alt"></i></button>
                        </div>
                        <div className="cart-info-group">
                            <div className="cart-info">
                                <h6><a onClick={() => navigate('/product-single')} >existing product name</a></h6>
                                <p>Unit Price - $8.75</p>
                            </div>
                            <div className="cart-action-group">
                                <div className="product-action">
                                    <button className="action-minus" title="Quantity Minus"><i className="icofont-minus"></i></button>
                                    <input className="action-input" title="Quantity Number" type="text" name="quantity" value="1" />
                                    <button className="action-plus" title="Quantity Plus"><i className="icofont-plus"></i></button>
                                </div>
                                <h6>$56.98</h6>
                            </div>
                        </div>
                    </li>
                </ul>
                <div className="cart-footer">
                    <button className="coupon-btn">Do you have a coupon code?</button>
                    <form className="coupon-form">
                        <input type="text" placeholder="Enter your coupon code" />
                        <button type="submit"><span>apply</span></button>
                    </form>
                    <a className='cart-checkout-btn' onClick={() => navigate('/checkout')}>
                        <span className="checkout-label">Proceed to Checkout</span>
                        <span className="checkout-price">$369.78</span>
                    </a>
                </div>
            </aside>

            <aside className="nav-sidebar">
                <div className="nav-header">
                    <a ><img src={require("../assets/images/logo.png")} alt="logo" /></a>
                    <button className="nav-close" onClick={handleclose}><i className="icofont-close"></i></button>
                </div>
                <div className="nav-content">


                    <ul className="nav-list">

                        <li><a className='nav-link' onClick={() => navigate('/')}><i className="icofont-home"></i>Home</a></li>
                        {clist.map((x) => (
                            <li key={x.id}><a className='nav-link' onClick={() => navigate(slugify(x.category_name))}><i className="icofont-page"></i>{x.category_name}</a></li>
                        ))}
                        <li><a className='nav-link' onClick={() => navigate('/weddingwebsite')}><i className="icofont-food-cart"></i>Wedding Website</a></li>

                        <li><a className='nav-link' onClick={() => navigate('/about')}><i className="icofont-info-circle"></i>about us</a></li>
                        <li><a className='nav-link' onClick={() => navigate('/contact')}><i className="icofont-contacts"></i>contact us</a></li>
                    </ul>
                    <div className="nav-info-group">
                        <div className="nav-info">
                            <i className="icofont-ui-touch-phone"></i>
                            <p>
                                <small>call us</small>
                                <span>+91 9865230900</span>
                            </p>
                        </div>

                    </div>

                </div>
            </aside>

            <div className="mobile-menu">
                <a onClick={() => navigate('/')} title='Home Page'>
                    <i className="fas fa-home"></i>
                    <span>Home</span>
                </a>
                <a onClick={handleshow} className="cate-btn" title="Category List">
                    <i className="fas fa-list"></i>
                    <span>category</span>
                </a>

                {/* <a onClick={() => navigate('/wishlist')} title='Wishlist'>
                    <i className="fas fa-heart"></i>
                    <span>wishlist</span>
                    <sup>0</sup>
                </a> */}

                <a href='https://wa.me/9865230900' target="_blank" title='WhatsApp'>
                    <i className="fab fa-whatsapp"></i>
                    <span>WhatsApp</span>
                </a>
            </div>

            <div className="modal fade" id="product-view">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <button className="modal-close icofont-close" data-bs-dismiss="modal"></button>
                        <div className="product-view">
                            <div className="row">
                                <div className="col-md-6 col-lg-6">
                                    <div className="view-gallery">
                                        <div className="view-label-group">
                                            <label className="view-label new">new</label>
                                            <label className="view-label off">-10%</label>
                                        </div>
                                        <ul className="preview-slider slider-arrow">
                                            <li><img src={require("../assets/images/product/01.jpg")} alt="product" /></li>
                                            <li><img src={require("../assets/images/product/01.jpg")} alt="product" /></li>
                                            <li><img src={require("../assets/images/product/01.jpg")} alt="product" /></li>
                                            <li><img src={require("../assets/images/product/01.jpg")} alt="product" /></li>
                                            <li><img src={require("../assets/images/product/01.jpg")} alt="product" /></li>
                                            <li><img src={require("../assets/images/product/01.jpg")} alt="product" /></li>
                                            <li><img src={require("../assets/images/product/01.jpg")} alt="product" /></li>
                                        </ul>
                                        <ul className="thumb-slider">
                                            <li><img src={require("../assets/images/product/01.jpg")} alt="product" /></li>
                                            <li><img src={require("../assets/images/product/01.jpg")} alt="product" /></li>
                                            <li><img src={require("../assets/images/product/01.jpg")} alt="product" /></li>
                                            <li><img src={require("../assets/images/product/01.jpg")} alt="product" /></li>
                                            <li><img src={require("../assets/images/product/01.jpg")} alt="product" /></li>
                                            <li><img src={require("../assets/images/product/01.jpg")} alt="product" /></li>
                                            <li><img src={require("../assets/images/product/01.jpg")} alt="product" /></li>
                                        </ul>
                                    </div>
                                </div>
                                {/* <div className="col-md-6 col-lg-6">
                                    <div className="view-details">
                                        <h3 className="view-name">
                                            <a onClick={() => navigate('/carddetails/1')}>existing product name</a>
                                        </h3>
                                        <div className="view-meta">
                                            <p>SKU:<span>1234567</span></p>
                                            <p>BRAND:<a >radhuni</a></p>
                                        </div>
                                        <div className="view-rating">
                                            <i className="active icofont-star"></i>
                                            <i className="active icofont-star"></i>
                                            <i className="active icofont-star"></i>
                                            <i className="active icofont-star"></i>
                                            <i className="icofont-star"></i>
                                            <a onClick={() => navigate('/carddetails/1')}>(3 reviews)</a>
                                        </div>
                                        <h3 className="view-price">
                                            <del>$38.00</del>
                                            <span>$24.00<small>/per kilo</small></span>
                                        </h3>
                                        <p className="view-desc">Lorem ipsum dolor sit amet consectetur adipisicing elit non tempora
                                            magni repudiandae sint suscipit tempore quis maxime explicabo veniam eos
                                            reprehenderit fuga</p>
                                        <div className="view-list-group">
                                            <label className="view-list-title">tags:</label>
                                            <ul className="view-tag-list">
                                                <li><a >organic</a></li>
                                                <li><a >vegetable</a></li>
                                                <li><a >chilis</a></li>
                                            </ul>
                                        </div>
                                        <div className="view-list-group">
                                            <label className="view-list-title">Share:</label>
                                            <ul className="view-share-list">
                                                <li><a className="icofont-facebook" title="Facebook"></a></li>
                                                <li><a className="icofont-twitter" title="Twitter"></a></li>
                                                <li><a className="icofont-linkedin" title="Linkedin"></a></li>
                                                <li><a className="icofont-instagram" title="Instagram"></a></li>
                                            </ul>
                                        </div>
                                        <div className="view-add-group">
                                            <button className="product-add" title="Add to Cart">
                                                <i className="fas fa-shopping-basket"></i>
                                                <span>add to cart</span>
                                            </button>
                                            <div className="product-action">
                                                <button className="action-minus" title="Quantity Minus"><i
                                                    className="icofont-minus"></i></button>
                                                <input className="action-input" title="Quantity Number" type="text" name="quantity"
                                                    value="1" />
                                                <button className="action-plus" title="Quantity Plus"><i
                                                    className="icofont-plus"></i></button>
                                            </div>
                                        </div>
                                        <div className="view-action-group">
                                            <a className="view-wish wish" title="Add Your Wishlist">
                                                <i className="icofont-heart"></i>
                                                <span>add to wish</span>
                                            </a>
                                            <a className='view-compare' onClick={() => navigate('/compare')} title='Compare This Item'>
                                                <i className="fas fa-random"></i>
                                                <span>Compare This</span>
                                            </a>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
